import React, { Component } from "react";
import CustomTopoChloroplethMap from "./CustomTopoChloroplethMap";
import RadioControlsForMap from './RadioControlsForMap';
import { tagToColor } from "../maps";
import SocialMediaButtons from './SocialMediaButtons';

class RadioBasedCustomMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true
        };
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {

        // fetch map data
        fetch(this.props.mapData.dataSource)
            .then(response => response.json())
            .then(data1 => {
                // console.log(data);
                const radioKeys = Object.keys(data1);
                // console.log(keys);

                fetch(this.props.mapData.customTopoJsonSource)
                    .then(response => response.json())
                    .then(data2 => {
                        this.setState({
                            customTopoJson: data2,
                            isLoading: false,
                            data: data1,
                            currentData: data1[radioKeys[0]],
                            radioKeys: radioKeys,
                            chosenRadio: radioKeys[0],
                        });
                    });
                    // console.log(this.state);

                // this.setState({
                //     data: data,
                //     currentData: data[radioKeys[0]],
                //     radioKeys: radioKeys,
                //     chosenRadio: radioKeys[0],
                // });
            });
        
        // fetch custom topo json
        
    }
    handleChange(value) {
        // console.log(value);
        this.setState({
            chosenRadio: value,
            currentData: this.state.data[value]
        });
    }

    render() {
        if (this.state.isLoading) {
            return (
        //     <div className="loadingOval">
        //         Loading...
        // </div>
                <div className="text-center">
                    <div className="spinner-border btLoadingOval" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
        );
        }
        return (
            <div className="mapContainer container-fluid">
                {this.props.helmetComp}
                <div className="mapTitle">
                    <h3 className="mapHeading">
                        {this.props.mapTitle}
                    </h3>
                </div>
                {/* <div className="row"> */}
                    {/* <div className="col-md-9 col-sm-12 col-xs-12"> */}
                <div className="mapPlusControls">
                    <div className="mapComponent">
                        <CustomTopoChloroplethMap
                            data={this.state.currentData}
                            customTopoJson={this.state.customTopoJson}
                            key={this.state.chosenRadio}
                            stats={this.props.stats[this.state.chosenRadio]}
                            scalingFactor={this.props.mapData.scalingFactor ? this.props.mapData.scalingFactor:1}
                            topoJsonScope={this.props.mapData.topoJsonScope}
                            scaleValue={this.props.mapData.scaleValue}
                            projectionCoordinates={this.props.mapData.projectionCoordinates}
                            scaleMultiplier={this.props.mapData.scaleMultiplier}
                            // multiColored={this.props.mapData.multiColored?this.props.mapData.multiColored:false}
                    />
                    </div>

                    {/* <div className={"col-md-3 col-sm-12 col-xs-12 controlsPane " + this.props.mapData.extendControlsVertically ? "controlsPaneExtended" : ""}> */}
                    <div className="controlsPane">
                        <div className="mapRadios">
                            <RadioControlsForMap radioKeysPreset={this.props.mapData.radioKeysPreset ? this.props.mapData.radioKeysPreset : null} handleChange={this.handleChange} radioKeys={this.state.radioKeys} textAboveMapControls={this.props.mapData.textAboveMapControls || "Choose a parameter"} />
                        </div>
                        <div className="mapCardTagsOnMapPage">
                            {this.props.mapData["tags"].map((tag, i) => (
                                <span key={`mapTagKey${i}`} className="badge badge-dark mapTag" style={{ backgroundColor: tagToColor[tag] }}>{tag}</span>
                            ))}
                        </div>
                        <div className="dataSourceAndCitations">
                            {this.props.mapData.citationSource === "" ? null : <p><a href={this.props.mapData.citationSource} target="_blank" rel="noopener noreferrer">data source</a></p>}
                        </div>
                        <div className="otherInfo">
                            <SocialMediaButtons shareTitle={this.props.mapTitle} shareUrl={window.location.href} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RadioBasedCustomMap;